import { isVolatile } from "@/__main__/constants.mjs";
import type { FromModel, ModelDefinition } from "@/__main__/data-model.mjs";
import createModel, { Optional } from "@/__main__/data-model.mjs";
import { NOTIFICATION_SEVERITY_LEVELS } from "@/app/constants.mjs";

export const model = {
  id: Number,
  message: String,
  action: String,
  link: Optional(String),
  severity: String,
  routes: [String],
  excludedAppVersions: [String],
  includedAppVersions: [String],
} satisfies ModelDefinition;

const AppNotificationsModel = createModel({
  data: {
    notifications: [model],
  },
}).transform([model], (data) => {
  const notifications = data?.data?.notifications
    ?.sort((a, b) => b.id - a.id)
    ?.sort(
      (a, b) =>
        NOTIFICATION_SEVERITY_LEVELS.indexOf(a.severity) -
        NOTIFICATION_SEVERITY_LEVELS.indexOf(b.severity),
    );

  notifications[isVolatile] = true;

  return notifications;
});

export default AppNotificationsModel;

export type AppNotifications = FromModel<typeof AppNotificationsModel>;
